export default __webpack_public_path__ + "static/media/pin-8x10px-pink.e56e77b4.svg";